"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummonGreaterElementalServantAbilityHandler = exports.SummonGreaterElementalServantActorAbilityFactory = exports.SummonGreaterElementalServantAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const enums_1 = require("../../core/enums");
const ActorType_1 = require("../../core/actors/ActorType");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class SummonGreaterElementalServantAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SummonGreaterElementalServant;
        this.__typeName = "SummonGreaterElementalServant";
    }
}
exports.SummonGreaterElementalServantAbilityArgs = SummonGreaterElementalServantAbilityArgs;
let SummonGreaterElementalServantActorAbilityFactory = class SummonGreaterElementalServantActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SummonGreaterElementalServant", "Self", 4);
    }
};
SummonGreaterElementalServantActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SummonGreaterElementalServant")
], SummonGreaterElementalServantActorAbilityFactory);
exports.SummonGreaterElementalServantActorAbilityFactory = SummonGreaterElementalServantActorAbilityFactory;
let SummonGreaterElementalServantAbilityHandler = class SummonGreaterElementalServantAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invoker = container.getActor(ability.invokerId);
        const crystalKeys = Array.of("SonicCrystalActive", "FireCrystalActive", "NatureCrystalActive", "FrostCrystalActive");
        if (!crystalKeys.every(key => container.readLocal(ability.invokerId, key, false))) {
            return;
        }
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                const servantArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.GreaterElementalServant, invoker.level, 
                // attributes...
                Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
                    let multiplier = 1;
                    // switch (+key) {
                    //   case AttributeType.Power:
                    //     value = getValueOrDefault(invoker.maxAttributeValues, AttributeType.Focus, 0);
                    //     break;
                    //   case AttributeType.Focus:
                    //     value = getValueOrDefault(invoker.maxAttributeValues, AttributeType.Focus, 0);
                    //     break;
                    // }
                    pet[key] = Math.round(value * multiplier);
                    return pet;
                }, {}), {
                    [enums_1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("ElementalBlast").mk(),
                })
                    .withPlayerId(invoker.playerId);
                const servantId = container.summonCompanion(sequence, ability.invokerId, servantArgs);
                container.registerEventHandlerScript(servantId, EventType_1.EventType.Tick, Schedule_1.Schedule.Unlimited, "CrystalsActive_OnTick", {});
            }
        });
    }
};
SummonGreaterElementalServantAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SummonGreaterElementalServant)
], SummonGreaterElementalServantAbilityHandler);
exports.SummonGreaterElementalServantAbilityHandler = SummonGreaterElementalServantAbilityHandler;
